/**
 * Scrolls a question/anchor element into view with an offset for the top menu bar.
 * Used across Deepchat, PMR (StudyChat), and Summarization features.
 */
export const scrollQuestionIntoView = (anchorId: string) => {
  const element = document.getElementById(anchorId);
  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY - (48 + 24); // Menu + 1em padding
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
